import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import LeftSidebar from "../../components/left-sidebar";
import TopBar from "../../components/topbar";
import SocialMediaPost from "../../components/Social-wall-post";
import SideWidgets from "../../components/SideWidgets";
import Groups from "../Groups";
import Settings from "../Settings";
import ProfilePage from "../ProfilePage";
import Members from '../Members';
import Profile from '../Profile';
import Events from "../Events";
import Jobs from "../Jobs";
import IndividualJobPost from "../Jobs/IndividualJobPost.jsx";
import NotificationsPage from "../NotificationsPage";
import Forum from "../Forum";
import { ProfileSettings } from "../ProfilePage/ProfileSettings/index.jsx";
import { Following } from "../../components/Following/index.jsx";
import { Followers } from "../../components/Followers/index.jsx";
import { Ipost } from "../../components/Ipost"
import { WorkExperience } from "../../components/WorkExperience/index.jsx";
import { SearchedResults } from "../../components/SearchedResults";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { CreateJob } from "../Jobs/CreateJob/index.jsx";
import { InterestedJobCandidates } from "../Jobs/InterestedJobCandidates/index.jsx";
import MemberForm from "../Members/MemberForm.jsx";
import ValidateUser from "../ValidateUser/ValidateUser.jsx";
import V2PhotoGallery from "../PhotoGallery/V2PhotoGallary.jsx";
import MessagingPage from "../Chat2/MessagingPage.jsx";
import TopicPage from "../Forum/TopicPage.jsx";
import DiscussionPage from "../Forum/DiscussionPage.jsx";
import ForumPost from "../Forum/ForumPost.jsx";
import { CheckCircle2, Loader2, Mail, Menu, RefreshCw, Timer, X } from "lucide-react";
import RightSidebar from "../../components/SideWidgets/RightSidebar.jsx";
import BusinessConnect from "../BusinessConnect/BusinessConnect.jsx";
import CreateBusiness from "../BusinessConnect/CreateBusiness.jsx";
import BusinessVerificationPanel from "../BusinessConnect/BusinessVerificationPanel.jsx";
import BusinessConnectDetails from "../BusinessConnect/BusinessConnectDetails.jsx";
import SponsorshipConnect from "../Sponsorships/SponsorshipConnect.jsx";
import CreateSponsorship from "../Sponsorships/CreateSponsorship.jsx";
import SponsorshipDetails from "../Sponsorships/SponsorshipDetails.jsx";
import SponsorshipVerificationPanel from "../Sponsorships/SponsorshipVerificationPanel.jsx";
import NewsUpdatesPage from "../NewsV2/NewsUpdatesPage.jsx";
import NewsDetailPage from "../NewsV2/NewsDetailPage.jsx";
import CreateNewsPage from "../NewsV2/CreateNewsPage.jsx";
import DraftsPage from "../NewsV2/DraftsPage.jsx";
import AnalyticsPage from "../NewsV2/AnalyticsPage.jsx";
import ScrollToTop from "../../components/ScrollToTop.jsx";
import ProhibitedKeywords from "../../pages/ProhibitedKeywords/ProhibitedKeywords.jsx"
import NotificationCenterPage from "../NotificationCenterPage/NotificationCenterPage.jsx";
import UserVerification from "../UserVerification/UserVerification.jsx";
import { useCookies } from "react-cookie";
// import { PullToRefresh, PullDownContent, ReleaseContent, RefreshContent } from "react-js-pull-to-refresh";
import PullToRefresh from 'react-simple-pull-to-refresh';
import MobileBottomNavigation from "../../components/MobileBottomNavigation/MobileBottomNavigation.jsx";
import RoleManagement from "../ManageRole/RoleManagement.jsx";
import socket from "../../contexts/socket.jsx";
import { toast } from "react-hot-toast";
import ForumHome from "../ForumV3/ForumHome.jsx";
import PostDetail from "../ForumV3/PostDetail.jsx";
import axios from "axios";
import EditNewsPage from "../NewsV2/EditNewsPage.jsx";
const Dashboard = ({ handleLogout }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get('search');
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profile);
  const portalInfo = useSelector((state) => state.portalInfo.data);
  const portalType = portalInfo?.portalType || 'Community';
  // const profileVerification = useSelector((state) => state.profileVerification);
  const [cookie, setCookie, removeCookie] = useCookies('token');
  const [isMobile, setIsMobile] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [profileVerification, setProfileVerification] = useState(null);
  const toggleMobileSidebar = () => {
    setMobileSidebarOpen(!mobileSidebarOpen);
  };


   // Add OTP verification state
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpForm, setOtpForm] = useState({
    otp: '',
    loading: false,
    resendLoading: false,
    timer: 100, 
    canResend: false
  });
  const [otpError, setOtpError] = useState('');

  // Check if OTP verification is needed
  useEffect(() => {
    if (portalType === 'Community' && profile && profile.community_verified === false &&(![0,1].includes(profile.profileLevel))) {
      setShowOtpModal(true);
    }
  }, [portalType, profile]);

  // Timer effect for OTP modal
  useEffect(() => {
    let interval = null;
    if (showOtpModal && otpForm.timer > 0) {
      interval = setInterval(() => {
        setOtpForm(prev => ({
          ...prev,
          timer: prev.timer - 1,
          canResend: prev.timer <= 1
        }));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showOtpModal, otpForm.timer]);

  // Format timer display
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Handle OTP verification
  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setOtpError('');
    
    if (!otpForm.otp || otpForm.otp.length !== 4) {
      setOtpError("Please enter a valid 4-digit OTP");
      return;
    }

    setOtpForm(prev => ({ ...prev, loading: true }));

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/alumni/verify-email-otp`, {
        email: profile.email,
        otp: otpForm.otp
      });

      if (response.data.success) {
        toast.success("Email verified successfully!");
        setShowOtpModal(false);
        // Update profile state to reflect verification
        // You might want to dispatch a Redux action here to update the profile state
        window.location.reload(); // Temporary solution to refresh profile data
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Invalid OTP. Please try again.";
      setOtpError(errorMsg);
      setOtpForm(prev => ({ ...prev, otp: '' }));
    } finally {
      setOtpForm(prev => ({ ...prev, loading: false }));
    }
  };

  // Handle OTP resend
  const handleResendOtp = async () => {
    setOtpForm(prev => ({ ...prev, resendLoading: true }));

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/alumni/resend-verification-otp`, {
        email: profile.email
      });

      if (response.data.success) {
        toast.success("New verification code sent to your email");
        setOtpForm(prev => ({
          ...prev,
          timer: 100,
          canResend: false,
          otp: ''
        }));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error sending verification code");
    } finally {
      setOtpForm(prev => ({ ...prev, resendLoading: false }));
    }
  };


  useEffect(()=>{
    if(profile.community_verified === false && portalType === 'Community' && !([0,1].includes(profile.profileLevel))){
      
      handleResendOtp()
    }
  },[profile])



  useEffect(() => {
    const handleConnect = () => {
      console.log("🔄 Socket reconnected, reloading data...");
      // loadUsers(); // Reload users when socket reconnects
    };

    const handleDisconnect = () => {
      console.log("❌ Socket disconnected");
    };

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
    };
  }, []);



  const closeMobileSidebar = () => {
    setMobileSidebarOpen(false);
  };


  const handleRefresh = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        window.location.reload();
        resolve();
      }, 100);
    });
  };


  const fetchUserVerification = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user-verification/user/${profile._id}`);
      if (!response.ok) {
        throw new Error('Failed to fetch profile verification');
      }
      const data = await response.json();
      setProfileVerification(data);
    } catch (error) {
      console.error('Error fetching profile verification:', error.message);
    }
  };

  useEffect(() => {
    fetchUserVerification();
  }, []);

  useEffect(() => {
    console.log("profileVerification", profileVerification)
    if (portalType !== 'Community') {
      if (profile?._id === undefined || profileVerification?.accountDeleted === true || (profileVerification?.expirationDate && new Date(profileVerification?.expirationDate) < new Date())) {
        // console.log("alksdfjalskdfj asdf adsfsafasfadfafafasfsafasdfffffffff")
        toast.dismiss();
        toast.error('Your account has been deleted or has expired. Please contact Admin.');
        removeCookie('token');
        navigate("/login");
        //  window.location.href = "/login";
      }
    }

  }, [profileVerification?.accountDeleted, profileVerification?.expirationDate]);


  useEffect(() => {
    const checkMobile = () => {
      // Check for touch capability and screen size
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth <= 768;
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Mobile device regex (excluding tablets)
      const mobileRegex = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i;
      const isMobileUA = mobileRegex.test(userAgent.toLowerCase());

      // Exclude tablets
      const isTablet = /ipad|android(?!.*mobile)|tablet/i.test(userAgent.toLowerCase());

      const isMobileDevice = (isTouchDevice && isSmallScreen && isMobileUA) && !isTablet;
      setIsMobile(isMobileDevice);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const mainContent = () => (
    <div className="">

      <Routes>
        <Route path="/groups/*" element={<Groups />} />
        {searchQuery && (
          <Route
            path="/*"
            element={<SearchedResults searchQuery={searchQuery} />}
          />
        )}
        {!searchQuery && (
          <Route
            path="/*"
            element={
              <div className="md:max-w-7xl mx-auto md:p-4">
                <div className="grid grid-cols-12 gap-4">
                  {/* Left Sidebar - Sticky */}
                  <div className="col-span-12 lg:col-span-3 hidden lg:block">
                    <div className="sticky top-4">
                      <SideWidgets />
                    </div>
                  </div>

                  {/* Middle Column - Wider and Scrollable */}
                  <div className="col-span-12 lg:col-span-6">
                    <SocialMediaPost showCreatePost={true} />
                  </div>

                  {/* Right Sidebar - Sticky */}
                  <div className="col-span-12 lg:col-span-3 hidden lg:block">
                    <div className="sticky top-4">
                      <RightSidebar />
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        )}

        {/* All other routes remain the same */}
        {/* <Route path="/donations/*" element={<Donations />} /> */}


        {/* all business connect routes */}
        <Route path="/business-connect" element={<BusinessConnect />} />
        <Route path="/business-connect/:id/" element={<BusinessConnectDetails />} />
        <Route path="/business-connect/create" element={<CreateBusiness />} />
        <Route path="/business-connect/edit/:id" element={<CreateBusiness />} />
        <Route path="/business-connect/admin/verify" element={<BusinessVerificationPanel />} />

        {/* all sponsorship routes */}
        <Route path="/sponsorship-connect" element={<SponsorshipConnect />} />
        <Route path="/sponsorship-connect/:id/" element={<SponsorshipDetails />} />
        <Route path="/sponsorship-connect/create" element={<CreateSponsorship />} />
        <Route path="/sponsorship-connect/edit/:id" element={<CreateSponsorship />} />
        <Route path="/sponsorship-connect/admin/verify" element={<SponsorshipVerificationPanel />} />


        {/* all newsv2 routes */}
        <Route path="/news/*" element={<NewsUpdatesPage />} />
        <Route path="/news/create" element={<CreateNewsPage />} />
        <Route path="/news/:id" element={<NewsDetailPage />} />
        <Route path="/news/drafts" element={<DraftsPage />} />
        <Route path="/news/analytics" element={<AnalyticsPage />} />
        <Route path="/news/edit/:id" element={<EditNewsPage />} /> 
        <Route path="/prohibited-keywords" element={<ProhibitedKeywords />} />


        {/* admin routes */}
        <Route path="/admin/user-verification" element={<UserVerification />} />



        {/* <Route path="/guidance/*" element={<Guidance />} /> */}
        <Route path="/photo-gallery/*" element={<V2PhotoGallery />} />
        <Route path="/chatv2">
          <Route index element={<MessagingPage />} />
          <Route path=":userId" element={<MessagingPage />} />
        </Route>
        {/* <Route path="/sponsorships/*" element={<Sponsorships />} /> */}
        <Route path="/members/*" element={
          <div className="w-full">
            <Members showHeading={true} />
          </div>
        } />
        <Route path="/members/create" element={
          <MemberForm name='member' />
        } />
        <Route path="/members/:id/*" element={<Profile />} />
        <Route path="/notifications/*" element={<NotificationCenterPage />} />
        <Route path="/events/*" element={<Events />} />
        <Route path="/jobs/*" element={<Jobs />} />
        <Route path="/jobs/create" element={<CreateJob />} />
        <Route path="/jobs/candidates" element={<InterestedJobCandidates />} />
        <Route path="/settings/*" element={<Settings />} />
        <Route path="/jobs/:_id/:title" element={<IndividualJobPost />} />
        <Route path="/posts/:_id/" element={<Ipost />} />
        <Route path="/internships/:_id/:title" element={<IndividualJobPost />} />


        {/* <Route path="/forums/*" element={<Forum />} />
        <Route path="/forums/category/:categoryId" element={<TopicPage />} />
        <Route path="/forums/category/:categoryId/topic/:topicId" element={<ForumPost />} />
        <Route path="/forums/category/:categoryId/topic/:topicId/post/:postId" element={<DiscussionPage />} /> */}
       <Route path="/forum" element={<ForumHome />} />
        <Route path="/forum/posts/:postId" element={<PostDetail />} />

        <Route path="/profile/*" element={<ProfilePage />} />
        <Route path="/profile/:id/following" element={<Following />} />
        <Route path="/profile/:id/followers" element={<Followers />} />
        <Route path="/profile/workExperience" element={<WorkExperience />} />
        <Route path="/profile/profile-settings" element={<ProfileSettings />} />
        {/* <Route path="/news/*" element={
                <div className="w-full">
                  <News />
                </div>
              } />
              <Route path="/news/:id/*" element={<NewsDetails />} />
              <Route path="/news/:id/edit" element={<CreateNews />} />
              <Route path="/news/createNews" element={<CreateNews />} /> */}
        <Route path="/validate-user" element={<ValidateUser />} />
        <Route path="/manage-roles/*" element={<RoleManagement />} />

      </Routes>
    </div>
  )
  return (
    <>
      {/* Desktop TopBar - No hamburger menu */}
      <div className="hidden lg:block fixed top-0 w-full z-50">
        <div className="flex justify-between dynamic-site-bg py-3 px-5 shadow-lg">

          <div className="w-full mx-auto">

            <TopBar handleLogout={handleLogout} />
          </div>
        </div>
      </div>
      <div className="flex h-screen w-full overflow-hidden">
        <ScrollToTop targetId="main-scroll" />


        {/* Desktop Sidebar - Collapsed by default, expands on hover */}
        <div className="hidden lg:block">
          <LeftSidebar onNavigate={() => { }} isMobile={false} isExpanded={false} />
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Top Bar with Mobile Hamburger Menu */}
          <div className="flex items-center dynamic-site-bg py-2 md:px-5 px-2 relative z-50 shadow-lg lg:hidden">
            <button
              onClick={toggleMobileSidebar}
              className="p-2 rounded-md hover:bg-white/20 transition-all duration-200 mr-4 hover:scale-105 shadow-lg"
            >
              <Menu className="h-6 w-6 text-white" />
            </button>
            <div className="flex-1">
              <TopBar handleLogout={handleLogout} />
            </div>
          </div>

          {/* Desktop TopBar - No hamburger menu */}
          <div className="hidden lg:block h-[5rem]">
            {/* <div className="dynamic-site-bg py-3 px-5 shadow-lg">
              <div className="text-white font-semibold text-lg absolute left-[0.5%] top-[0%]">
                <img src="/v2/logo2.png" alt="InsideOut Logo" className="w-[200px] h-[99px] mx-auto rounded-lg object-contain transition-all duration-300" />
              </div>
              <div className="max-w-6xl mx-auto">

                <TopBar handleLogout={handleLogout} />
              </div>
            </div> */}
          </div>

          {/* Mobile Sidebar Overlay */}
          {mobileSidebarOpen && (
            <div
              className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
              onClick={closeMobileSidebar}
            />
          )}

          {/* Mobile Sidebar */}
          <div className={`
          lg:hidden fixed top-0 left-0 h-full shadow-2xl z-50
          transform transition-transform duration-300 ease-in-out
          ${mobileSidebarOpen ? 'translate-x-0' : '-translate-x-full'}
          w-72 max-w-[85vw]
        `}>
            <div className="h-full">
              <LeftSidebar onNavigate={closeMobileSidebar} isMobile={true} isExpanded={true} />
            </div>
          </div>

          {/* Main Content */}
            <div className="flex-1 relative overflow-hidden">
            <div id="main-scroll" className="h-full overflow-auto bg-gray-100 overscroll-y-contain md:py-4 pb-[50px]">
              {mainContent()}
            </div>

            {/* OTP Verification Modal - Only covers main content area */}
            {showOtpModal && portalType === 'Community' && profile?.community_verified === false && (
              <div className="absolute inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[1000] p-4">
                <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
                  {/* Header */}
                  <div className="dynamic-site-bg text-white px-2 py-3 rounded-t-2xl">
                    <div className="text-center">
                      <div className="w-[3rem] h-[3rem] bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-3 border border-white/30">
                        <Mail className="w-8 h-8" />
                      </div>
                      <h2 className="text-xl font-semibold">Verify Your Email</h2>
                      <p className="text-white/80 text-sm mt-1">
                        Please verify your email to access the community
                      </p>
                      <p className="text-white/70 text-xs mt-2">
                        Code sent to {profile?.email}
                      </p>
                    </div>
                  </div>

                  {/* Body */}
                  <div className="px-3 py-1">
                    {otpError && (
                      <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg mb-4 text-center">
                        <p className="font-medium">{otpError}</p>
                      </div>
                    )}
                    
                    <form onSubmit={handleOtpVerification} className="space-y-4">
                      <div>
                       
                        <input
                          type="text"
                          value={otpForm.otp}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                            setOtpForm(prev => ({ ...prev, otp: value }));
                          }}
                          placeholder="Enter 4-digit code"
                          className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-purple-400 focus:ring-2 focus:ring-purple-400/20 transition-all text-center text-2xl font-bold tracking-widest"
                          maxLength={4}
                          autoFocus
                        />
                      </div>

                      {/* Timer */}
                      <div className="text-center">
                        {otpForm.timer > 0 ? (
                          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm">
                            <Timer className="w-4 h-4" />
                            <span>Code expires in {formatTime(otpForm.timer)}</span>
                          </div>
                        ) : (
                          <p className="text-red-500 text-sm">Code expired</p>
                        )}
                      </div>

                      {/* Buttons */}
                      <div className="space-y-3">
                        <button
                          type="submit"
                          disabled={otpForm.loading || !otpForm.otp || otpForm.otp.length !== 4}
                          className="w-full dynamic-site-bg text-white py-3 rounded-xl font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                        >
                          {otpForm.loading ? (
                            <>
                              <Loader2 className="w-4 h-4 animate-spin" />
                              Verifying...
                            </>
                          ) : (
                            <>
                              <CheckCircle2 className="w-4 h-4" />
                              Verify Email
                            </>
                          )}
                        </button>

                        {otpForm.canResend && (
                          <button
                            type="button"
                            onClick={handleResendOtp}
                            disabled={otpForm.resendLoading}
                            className="w-full border border-purple-200 text-purple-600 py-3 rounded-xl font-semibold hover:bg-purple-50 transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                          >
                            {otpForm.resendLoading ? (
                              <>
                                <Loader2 className="w-4 h-4 animate-spin" />
                                Sending...
                              </>
                            ) : (
                              <>
                                <RefreshCw className="w-4 h-4" />
                                Resend Code
                              </>
                            )}
                          </button>
                        )}
                      </div>

                      {/* Help text */}
                      <div className="text-center text-xs text-gray-500 mt-4">
                        <p>Didn't receive the code? Check your spam folder</p>
                    
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Mobile Bottom Navigation */}
        <MobileBottomNavigation />
      </div>


     
    </>
  );
};

export default Dashboard;
